import type { BadgeProps } from "@closer/ui";

type Tone = NonNullable<BadgeProps["tone"]>;

/**
 * Sözleşme durumu → rozet tonu — TEK yer.
 *
 * ### Neden bir eşleme dosyası
 *
 * Durum rozeti altı ayrı ekranda çiziliyordu ve her biri kendi kuralını yazmıştı: liste
 * yalnız `active` için yeşil verip kalan dokuz durumu griye topluyor, detay ekranı başka
 * bir ayrım kullanıyordu. Aynı sözleşme iki ekranda iki farklı renkte görünüyor, renk de
 * bir bilgi taşımıyordu.
 *
 * ### Ton bir DEĞERLENDİRME DEĞİL
 *
 * ⚠ `warning` "sorun var" demek değil, "senden bir şey bekleniyor" demek; `danger` da
 * "hata" değil, sözleşmenin sona erdirildiği anlamına geliyor. Yazılım hukuki bir hüküm
 * kurmuyor (CLOS-182'nin kuralı) — renk yalnız yaşam döngüsündeki yeri gösteriyor.
 *
 * ### ⚠ `Record<ContractStatus, Tone>` — kısmi DEĞİL
 *
 * Yeni bir durum eklendiğinde bu dosya derlenmiyor ve eksik ton derleme zamanında
 * yakalanıyor. `Partial` + varsayılan yazsaydık yeni durum sessizce gri çıkardı ve kimse
 * fark etmezdi.
 *
 * ### UI Tur 2 §5 eşlemesi (bağlayıcı spec, koordinatör kararıyla genişletildi): Yürürlükte/
 * Aktif/İmzalandı/Sonuçlandı/**Mutabık**=success · Onay Bekliyor/Beklemede/Askıda/İmza
 * Bekliyor=warning · İncelemede/Yorum Bekliyor=info · Revizyon/Müzakere=violet · Taslak/
 * Arşiv/Sona Ermiş=neutral · Reddedildi/Risk=danger.
 *
 * ⚠ `agreed` ("Mutabık") KARARI (koordinatör, önceki ACIK'e cevap): `success` kümesi —
 * olumlu bir TERMİNAL sonuç, "Sonuçlandı" ile aynı sınıf. `info` DEĞİL: ilk sürümde
 * "nötr ama dikkat çekici" ailesine (İncelemede) yakın sanılmıştı, ama mutabakat bir ARA
 * durum değil, tarafların üzerinde ANLAŞTIĞI bir sonuç.
 */
export const CONTRACT_STATUS_TONES = {
  draft: "neutral",
  in_review: "info",
  in_negotiation: "violet",
  awaiting_approval: "warning",
  agreed: "success",
  awaiting_signature: "warning",
  active: "success",
  expired: "neutral",
  terminated: "danger",
  archived: "neutral",
} as const satisfies Record<string, Tone>;

/**
 * Bilinmeyen durum `neutral` düşüyor ve bu bir KAÇIŞ DEĞİL: sunucu tanımadığımız bir
 * durum dizesi gönderirse rozet yine çizilmeli. Renk yerine metin taşır; renk uydurmak
 * kullanıcıya olmayan bir anlam verirdi.
 */
export function contractStatusTone(status: string): Tone {
  return (CONTRACT_STATUS_TONES as Record<string, Tone>)[status] ?? "neutral";
}
